/* tslint:disable */
/* eslint-disable */
/**
 * AGAIN-AGAIN API
 * backend api for tracking container movement for again-again
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Site,
    SiteFromJSON,
    SiteFromJSONTyped,
    SiteToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedSiteList
 */
export interface PaginatedSiteList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSiteList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSiteList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Site>}
     * @memberof PaginatedSiteList
     */
    results?: Array<Site>;
}

export function PaginatedSiteListFromJSON(json: any): PaginatedSiteList {
    return PaginatedSiteListFromJSONTyped(json, false);
}

export function PaginatedSiteListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedSiteList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(SiteFromJSON)),
    };
}

export function PaginatedSiteListToJSON(value?: PaginatedSiteList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(SiteToJSON)),
    };
}


